import http, { getLocale } from '../store/services/http-common';
import { getStoredUser, isAuthenticated } from './authentication';

const normalizeLocale = (value) => {
  const locale = String(value ?? '').toLowerCase();

  return locale === 'en' || locale === 'ar' ? locale : null;
};

/**
 * Persist the current UI language to the authenticated user's profile
 * so emails and server-side content match the selected language mode.
 */
export async function syncUserLocalePreference() {
  if (typeof window === 'undefined' || !isAuthenticated()) {
    return;
  }

  const storedLanguage = localStorage.getItem('appLanguage');
  if (!storedLanguage) {
    return;
  }

  const appLang = getLocale();
  const user = getStoredUser();
  const dbLang = normalizeLocale(user?.locale);

  if (dbLang === appLang) {
    return;
  }

  try {
    const response = await http.post('/locale', { locale: appLang.toUpperCase() });

    if (response?.data?.user) {
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
  } catch (error) {
    console.debug('[syncUserLocalePreference] failed', error?.response?.status ?? error?.message);
  }
}

/**
 * Apply the authenticated user's saved locale to the UI when no local preference exists yet.
 */
export function applyStoredUserLocale(dispatch, setLanguage) {
  if (typeof window === 'undefined' || !isAuthenticated()) {
    return;
  }

  if (localStorage.getItem('appLanguage')) {
    return;
  }

  const user = getStoredUser();
  const profileLang = normalizeLocale(user?.locale);

  if (profileLang) {
    dispatch(setLanguage(profileLang));
  }
}
